import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Slide, Zoom, Fade } from "react-awesome-reveal";

function HomeHeader() {
  const { t } = useTranslation();
  return (
    <header className="home-header u-mb-small">
      <div className="home-header__text-box">
        <h1 className="heading-primary">
          <Zoom triggerOnce>
            <div className="heading-primary--main">
              {t("home_heading_primary_message-1")}
              <span className="heading-primary--main-focus text-gradient-primary">
                {t("home_heading_primary_message-2")}
              </span>
            </div>
          </Zoom>

          <Slide direction="up" triggerOnce delay={200}>
            <span className="heading-primary--sub">
              {t("home_heading_primary_sub_message")}
            </span>
          </Slide>
        </h1>

        <Fade triggerOnce delay={400}>
          <div className="home-header__button-box">
            <Link to="contact" className="btn btn-red btn-shadow">
              {t("home_header_getquote_button")}
            </Link>
            <Link to="insurrances" className="btn btn-lightgray btn-shadow">
              {t("home_header_discover-products_button")}
            </Link>
          </div>
        </Fade>

        <Fade triggerOnce delay={600}>
          <div className="home-header__trust-badges">
            <span className="home-header__trust-badge">
              <span className="home-header__trust-badge-icon">✓</span>
              {t("home_header_trust_badge_cima")}
            </span>
            <span className="home-header__trust-badge">
              <span className="home-header__trust-badge-icon">✓</span>
              {t("home_header_trust_badge_clients")}
            </span>
            <span className="home-header__trust-badge">
              <span className="home-header__trust-badge-icon">✓</span>
              {t("home_header_trust_badge_since")}
            </span>
          </div>
        </Fade>
      </div>
    </header>
  );
}

export default HomeHeader;
